<ion-grid>
    <input type="hidden" id="allItens" [value]="_reviews? _reviews.length : 0">
    <ion-row [class]="'users-row ' +'page-'+getCurrentPage(i)" *ngFor="let review of _reviews; index as i" >
        <ion-col size="2" class="personal-user-data">
            <ion-row><img [src]="getImageUrl(review?.employee?.imageUrl)" default="" alt=""></ion-row>
            <ion-row><b>{{ review?.employee?.name }}</b></ion-row>
            <ion-row>{{ 'generic.group' | translate }}: <b>{{ review?.employee?.businessGroup }}</b></ion-row>
            <ion-row>{{ 'generic.unit' | translate }}: <b>{{ review?.employee?.businessUnit }}</b></ion-row>
            <ion-row>{{ 'generic.rank' | translate }}: <b>{{ review?.employee?.rank }}</b></ion-row>
            <ion-row>
                <div *ngIf="!isExportMode" (click)="openAiGeneralSummaryModalInternalEvent(review)">
                    {{ 'managerEvaluation.goToAiDetailedSummary' | translate | uppercase }}
                    <span class="bp-arrow-right"></span>
                </div>
            </ion-row>
        </ion-col>
        <ion-col size="10">
            <ion-row class="tables">
                <ion-col [size]="colFullSize ? 12 : 7">
                    <ng-container *ngIf="review?.userOverview">
                        <app-general-valuation-table [user]="review?.userOverview" [isManagement]="true">
                        </app-general-valuation-table>
                    </ng-container>
                </ion-col>
                <ion-col [size]="colFullSize ? 12 : 5">
                    <ng-container *ngIf="review?.userOverview">
                        <app-general-valuation-final-concepts-table [user]="review?.userOverview" [isManagement]="true">
                        </app-general-valuation-final-concepts-table>
                    </ng-container>
                </ion-col>
            </ion-row>
            <ion-row class="ai-summary">
                {{ review?.summarySeniorManagement }}
            </ion-row>
        </ion-col>
    </ion-row>
    <ng-container *ngIf="_reviews?.length < usersCount && !isExportMode">
        <ion-infinite-scroll (ionInfinite)="getReviewsForCalibrationGroupInternalEvent($event)">
            <ion-infinite-scroll-content loadingSpinner="bubbles">
            </ion-infinite-scroll-content>
        </ion-infinite-scroll>
    </ng-container>
</ion-grid>

